import { useEffect, useState } from "react";
import { InputOTP, InputOTPGroup, InputOTPSlot } from "@/components/ui/input-otp";
import { api } from "@/lib/api";

export const OTP_LENGTH = 4;

export default function OtpStep({ phone, onVerify, verifying, error, prefix }) {
  const [code, setCode] = useState("");
  const [cooldown, setCooldown] = useState(30);
  const [resendErr, setResendErr] = useState(null);
  useEffect(() => {
    const id = setInterval(() => setCooldown((c) => (c > 0 ? c - 1 : 0)), 1000);
    return () => clearInterval(id);
  }, []);
  const change = (v) => {
    setCode(v);
    if (v.length === OTP_LENGTH) onVerify(v);
  };
  const resend = async () => {
    try {
      await api.post("/auth/send-otp", { phone });
      setCooldown(30);
      setResendErr(null);
    } catch (e) {
      setResendErr(e.message);
    }
  };
  return (
    <div className="flex flex-col items-start gap-5">
      <div>
        <h1 className="text-[28px] font-extrabold">Enter the code</h1>
        <p className="text-[15px] text-[#475569] mt-1">Sent to {phone}</p>
      </div>
      <InputOTP maxLength={OTP_LENGTH} value={code} onChange={change} disabled={verifying} data-testid={`${prefix}-otp-input`}>
        <InputOTPGroup className="gap-3">
          {Array.from({ length: OTP_LENGTH }, (_, i) => (
            <InputOTPSlot key={i} index={i} className={`w-14 h-14 text-[22px] font-bold rounded-[12px] border bg-[#EEF2F9] ${error ? "border-[#DC2626]" : "border-[#DFE5F0]"}`} />
          ))}
        </InputOTPGroup>
      </InputOTP>
      {(error || resendErr) && <p className="text-[14px] text-[#DC2626]" data-testid={`${prefix}-otp-error`}>{error || resendErr}</p>}
      {verifying && <p className="text-[14px] text-[#64748B]">Verifying…</p>}
      {cooldown > 0 ? (
        <p className="text-[14px] text-[#64748B]">Resend code in 0:{String(cooldown).padStart(2, "0")}</p>
      ) : (
        <button className="t-link" onClick={resend} data-testid={`${prefix}-resend-otp`}>Resend code</button>
      )}
    </div>
  );
}
